/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const Typo3IconConfig = {
  name: 'Typo3Icon',
  height: 512,
  width: 448,
  svgPath: 'M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(Typo3IconConfig);
//# sourceMappingURL=typo3-icon.js.map